<template>
  <div class="max-w-lg mx-auto shadow-xl mt-4 p-4 bg-white feedback-new">
    <h1 class="text-3xl text-primary font-bold">
      {{ $t('menu.feedback') }}
    </h1>
    <p class="mt-8">
      {{ $t('feedback.welcomeMessage1') }}
    </p>
    <p>
      {{ $t('feedback.welcomeMessage2') }}
    </p>

    <hr class="my-4" />

    <FeedbackForm />
  </div>
</template>

<script setup lang="ts">
  import FeedbackForm from '&/FeedbackForm.vue'
</script>
